import { useEffect, useState, type MouseEvent } from 'react';
import { Brand } from '../components/Brand';
import { TALLY_FORM_ID } from './ManifestoCTA';

export function TopNav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const openTally = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (typeof window === 'undefined' || !window.Tally) return;
    window.Tally.openPopup(TALLY_FORM_ID, { layout: 'modal', width: 700, autoClose: 3000 });
  };

  return (
    <nav className={`top ${scrolled ? 'scrolled' : ''}`} data-screen-label="00 Nav">
      <div className="wrap row">
        <Brand withPulse href="/" />
        <div className="nav-links">
          <a href="https://playlist.furtif.fm">Playlists</a>
          <a href="/manifesto.html">Manifeste</a>
          <a href="#acces" className="btn" onClick={openTally}>Accès anticipé</a>
        </div>
      </div>
    </nav>
  );
}
